import {GetFormattedProductData} from '@/models/ProductOverviewModel'
import {getProductOverview} from '@/services/ProductsService/ProductOverview/productOverview'
import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'
import {useParams} from 'react-router-dom'

export const useProductOverview = () => {
  const {id} = useParams() // Extract id from URL parameters
  const safeId = useMemo(() => {
    const rawId = String(id ?? '').trim()

    if (!rawId || rawId.includes('..') || rawId.includes('/') || rawId.includes('\\')) {
      return ''
    }

    return /^[A-Za-z0-9._-]+$/.test(rawId) ? rawId : ''
  }, [id])

  const {data, isLoading} = useQuery({
    queryKey: ['PRODUCT', safeId],
    queryFn: () => getProductOverview(safeId),
    enabled: !!safeId, // Only run the query if we have a valid ID
  })

  const formattedData = useMemo(() => (data ? GetFormattedProductData(data) : {}), [data])

  return {
    productOverviewData: formattedData,
    isLoading,
    data,
  }
}
